module.exports = function getResource(label) {
    const resources = {
        usName: 'United States',
        caName: 'Canada',
        firstName: 'First name',
        lastName: 'Last name',
        address2Label: 'Apt #, Floor, etc.',
        add: 'Add',
        country: 'Country',
        streetAddress: 'Street address',
        city: 'City',
        phone: 'Phone',
        postalCode: 'Postal code',
        zipPostalCode: 'ZIP/Postal code',
        emailAddress: 'Email address',
        enterZipCodeText: 'Enter ZIP/Postal code to see City and State/Region.',
        region: 'Region',
        stateRegion: 'State/Region',
        province: 'Province',
        emailRequiredText: 'Your email address is required for shipping notifications and order tracking.'
    };

    return resources[label];
};
